import { createFileRoute } from '@tanstack/react-router';
import { AppPage } from '../pages/app';

export const Route = createFileRoute('/')({
  component: AppPage,
});
